import { OptionsLabel } from './NodeEditor.types';

export const convertToOptions = (options?: string[]) =>
  (options || []).map((v) => ({ value: v, label: OptionsLabel[v] }));
